import React from "react";
import ContactSection from "../components/ContactSection";

const ContactPage = () => {
  return (
    <main data-testid="contact-page">
      <ContactSection />
    </main>
  );
};

export default ContactPage;
